import { z } from "zod";

export const getHomeChargingEligibleVehiclesResponse = z.array(
  z.object({
    uuid: z.uuid(),
    vin: z.string(),
    registrationNumber: z.string(),
  }),
);

export type GetHomeChargingEligibleVehiclesResponse = z.infer<
  typeof getHomeChargingEligibleVehiclesResponse
>;
